/**
 * Query ArtBlocks API for all tokens
 */

const mints = [
  {
      "hash": "0x68ccf391d28860eb4d42d9d74cb9594b2e2e7518780c60ae4828b2761f0611e8",
      "tokenId": "429000000"
  },
  {
      "hash": "0xd653736409df45c3fb236475b5f7b4e64866020eb2cc880560cb64e13fb7674b",
      "tokenId": "429000001"
  },
  {
      "hash": "0xee87eb932204c0f1a6bb8b755c47a978552e92f333659f8c8a01dac0fd3a89f2",
      "tokenId": "429000002"
  },
  {
      "hash": "0x6bc3ac51c8b9deeec0120ff3f67ecdffd98cd654985e88441ce84718d3d42bbc",
      "tokenId": "429000003"
  },
  {
      "hash": "0x726b85541b16291e4fd987f5bb67675d503e7facbfdd18c4f87c3939e0d9acab",
      "tokenId": "429000004"
  },
  {
      "hash": "0x7913719bff7c223c1a5434742a709f40a56faf990f5dce7ad6cb0c2ee78e1cb4",
      "tokenId": "429000005"
  },
  {
      "hash": "0x38e175d1560ea8e3a820eb0179f8e322258fc378e3b046a72cc3b7b99d09dc65",
      "tokenId": "429000006"
  },
  {
      "hash": "0xf7c17254ac7d0daa0265f96b45c2ad228aed1b9b8f4ada89520cb434ec562a64",
      "tokenId": "429000007"
  },
  {
      "hash": "0x7de4daf12bcbb27ddbd1666f9fca43ff0418ac482d15b9f2cde6a57edc0bfaff",
      "tokenId": "429000008"
  },
  {
      "hash": "0x22850ef2f46118851d81ea316f6ffd25b6ef6649d66ec858a6416426340484de",
      "tokenId": "429000009"
  },
  {
      "hash": "0xdc2d1d0aa2eb3a6ecb8974ff25842608a5bdcb9395f066e01da9b2ca0c467aac",
      "tokenId": "429000010"
  },
  {
      "hash": "0x777df3ddd93c45a56e87c72e277a4f537b57a271c5559b38732997c4f777d4ed",
      "tokenId": "429000011"
  },
  {
      "hash": "0x12769c44cbbfc0d8efe3fdfb51b312ec8d56f8395fc8b66fd6b983429a7c93eb",
      "tokenId": "429000012"
  },
  {
      "hash": "0x4fac3600f3eb96539e56b119fa10b1df9d867ef87e7e6465d85571c06231eef4",
      "tokenId": "429000013"
  },
  {
      "hash": "0xab5e3ebcab3b60c8ed0d88eb46b1395b49e56b243eb0ee65947fef6c90ba4ca1",
      "tokenId": "429000014"
  },
  {
      "hash": "0xef395f1bbe42add6eeba2fa61a90f116ac9dd8c1d4d9942fbe8f538dc936ef92",
      "tokenId": "429000015"
  },
  {
      "hash": "0x9eb2cc84877ed3d84d7ed937cc9706482207d63fa36efb863f97bfb10179c06f",
      "tokenId": "429000016"
  },
  {
      "hash": "0xebecebe4122f3354d5f09475b62479988cb07ab7142b84e5d920c81d37f78c68",
      "tokenId": "429000017"
  },
  {
      "hash": "0x413a86ba384922898687a2a6c764647ebaa989b70354a0b5657cdb4872f22273",
      "tokenId": "429000018"
  },
  {
      "hash": "0x0fda1bc9374c0f6ea6e818ca823efbaf7d4ac375d1e020c917a13a219cd70087",
      "tokenId": "429000019"
  },
  {
      "hash": "0x345427057ae0325b343b7bea69e4099351eb2e4e27fd106ef22d5f7c6ee55932",
      "tokenId": "429000020"
  },
  {
      "hash": "0x5734e7f4a7f67d457525b79a833ee6718f1a8ed38bcc4820335c87c40123f790",
      "tokenId": "429000021"
  },
  {
      "hash": "0xd1f55f67032c6052965b0ab125bcd6e2e44ef39772a2089d444a2391b95f80ff",
      "tokenId": "429000022"
  },
  {
      "hash": "0xd86c84af754b310b347641235ccbfd04f005513214a268b31c5d298254604cb4",
      "tokenId": "429000023"
  },
  {
      "hash": "0xafa4aabe3b2abb245be5d243f7e2d98f3222bb972973cfd4fa0f1fc7f3c30a03",
      "tokenId": "429000024"
  },
  {
      "hash": "0xbd302cb8e7398e61468da4a30c7572847505e925d38fa3dfa61fb9e52fa636f4",
      "tokenId": "429000025"
  },
  {
      "hash": "0xd090b7672e01773d7a0554afb5a95e433074aaa6ee378e37e4ed3e07f94a82c7",
      "tokenId": "429000026"
  },
  {
      "hash": "0x17ea16c235c1f833c82b0be52b888104d6dc9d6b3552165b8d3d5de26bffa68f",
      "tokenId": "429000027"
  },
  {
      "hash": "0x1914bd359d8bd7e5e923311826a47790d254535d9d5c8986b1cfd34350657ad4",
      "tokenId": "429000028"
  },
  {
      "hash": "0xb672e1c68b0347faca8cf6d5abe777ffc4523a570719d0a330a08ed436fa35b5",
      "tokenId": "429000029"
  },
  {
      "hash": "0x0103463f028d4d657ffb0761f40a1d998e3799405ee31d6496f829284c961016",
      "tokenId": "429000030"
  },
  {
      "hash": "0x7cfc6a6f22edfaf304c59c23d3b10d4cc35e668012f2edbc6f52c42f2d630887",
      "tokenId": "429000031"
  },
  {
      "hash": "0x94038ec200ed59c02b6773bdd3a967cb078dbd25c0eed40edc91fef6746c1ffd",
      "tokenId": "429000032"
  },
  {
      "hash": "0xbc8ffd0dddc5201381ce071c39ffe90579fd812d8560ab7eb55a7952cf20b3f0",
      "tokenId": "429000033"
  },
  {
      "hash": "0x05e5b4097c4001a1ea51bbf879347bde37990224fa34b3497efc7327a3e2b481",
      "tokenId": "429000034"
  },
  {
      "hash": "0xd75f6c190501ea666fa854d090bda12fb53bdd062a7c1524ecffda27f9655cf4",
      "tokenId": "429000035"
  },
  {
      "hash": "0xb2dbf38c3503e397106c704240cd3f45149b8ad49c38ffbccf2c47e8529021c0",
      "tokenId": "429000036"
  },
  {
      "hash": "0x97f86c11cf6f15fc9ad0ad1e154cee181a044a827fa4e6f0415ff794d6550aa9",
      "tokenId": "429000037"
  },
  {
      "hash": "0x1e50bdbef43a37dd0f12d02ee9896040c2885a67f08ac86fcc20439603c59b3e",
      "tokenId": "429000038"
  },
  {
      "hash": "0x06485fd06ceaa7d17fcc737a08c66788298f0668f55e74b2a1ed8e2d3a71b5ce",
      "tokenId": "429000039"
  },
  {
      "hash": "0x04215b71c1cac3c2f6e7989a1d04378d6f54e0f3bb152c9a31b6cf7f77eaef86",
      "tokenId": "429000040"
  },
  {
      "hash": "0x315f33e3327e32e6ff00030620e58fd2acc95ea141f112f98365fb61a010f4b4",
      "tokenId": "429000041"
  },
  {
      "hash": "0x6f82c6c0e80c2ff2a358887f1dd2d2c795be4a7f851220cec083a12f7c52f19c",
      "tokenId": "429000042"
  },
  {
      "hash": "0x8aa3a3dbccdcb16eab9dea93a65f7db7d94452bfbe85ef94075ec0b2e89d3ad2",
      "tokenId": "429000043"
  },
  {
      "hash": "0x5f8e5366b1932243988a9694aabe84b2c23739d1b0b7db31766228ff77e02c54",
      "tokenId": "429000044"
  },
  {
      "hash": "0xd8057b0be62e9fd207680e63d074f50b92d422d94ee1ba3c2fe32e15362d9d29",
      "tokenId": "429000045"
  },
  {
      "hash": "0xa70c0efe7ca73b728376a3b82218be871ab99f336f507a1f02ca1a2dbc3cb298",
      "tokenId": "429000046"
  },
  {
      "hash": "0x70176e25a46b3da944cc14ffb62d239a08dc2e66fc864fef644e56be24a7d5be",
      "tokenId": "429000047"
  },
  {
      "hash": "0xc57c1fa81a46e7ec3d3964ff77d441657de5dfdac692352cf47ffd79f88c06bb",
      "tokenId": "429000048"
  },
  {
      "hash": "0xacc90ca282867d870f30269b5a77a812fce0592486033102f6711ce99df4d27a",
      "tokenId": "429000049"
  },
  {
      "hash": "0xe1389200b755ced691152cab1c9c6bb208b8b9c28749d8a8c2ba53d500b20f43",
      "tokenId": "429000050"
  },
  {
      "hash": "0x82eb45f36e5e2d1dc0a4aeb8340710e707617cef50fd24aa2f6ed055a1b3b86b",
      "tokenId": "429000051"
  },
  {
      "hash": "0xa2ca9ed2529c75ffad7929c31418893a292ce9bba445675a92887130b2c48696",
      "tokenId": "429000052"
  },
  {
      "hash": "0x69a5ebf72d8d616d66e87dce3ab13c8653d0828a2e4fa81743c9ec92ea73f594",
      "tokenId": "429000053"
  },
  {
      "hash": "0x9af2a4eca23da9cfb707088aeb8857043baf26b33c4dad1c7e2667e66b9345ce",
      "tokenId": "429000054"
  },
  {
      "hash": "0xcf8b46d50af9407e2e5ba9b4aba9417de92879b9b68f98e0d681118a4822eb5c",
      "tokenId": "429000055"
  },
  {
      "hash": "0xb59935dc2483edd61ac65417afd3e3161ead320a69925d244df27dc70979bec7",
      "tokenId": "429000056",
  }
];


// Set random mint if not in URL
if (!window.location.href.includes('token')) {
  const randomMint = Math.floor(Math.random() * mints.length);
  window.token = mints[randomMint];
}
else {
  window.token = {
    hash: window.location.href.split('token=')[1].split('/')[0],
    tokenId: window.location.href.split('token=')[1].split('/')[1],
    owner: mints.find(mint => mint.hash === window.location.href.split('token=')[1].split('/')[0]).owner
  }
}

// Set mint id label
document.getElementById('mintPreview').href = `https://www.artblocks.io/collections/presents/projects/0x99a9b7c1116f9ceeb1652de04d5969cce509b069/429/tokens/${window.token.tokenId}`;
document.getElementById('mintPreview').innerHTML = `
  Viewing mint #${parseInt(window.token.tokenId.substring(5))}
`;

// Insert each mint into the div with the id "mintsList"
mints.forEach(mint => {
  const mintLink = document.createElement('a');
  mintLink.classList.add('btn', 'btn-outline-secondary', 'col-6', 'col-md-4');
  mintLink.href = `./?token=${mint.hash}/${mint.tokenId}#mintLive`;

  mintLink.innerHTML = `<img src="https://media.artblocks.io/thumb/${mint.tokenId}.png" width="300" alt="Mint ${mint.hash}" />`;
  document.getElementById('mintsList').appendChild(mintLink);
});

// Set live artwork
// create iframe in preview div
const iframe = document.createElement('iframe');
iframe.src = `https://generator.artblocks.io/0x99a9b7c1116f9ceeb1652de04d5969cce509b069/${window.token.tokenId}`;
// Scale iframe to fit width with the aspect ratio of 16:9
iframe.width = '100%';
// Get document width
const docWidth = document.documentElement.clientWidth;
// Calculate iframe height
const iframeHeight = docWidth * 9 / 16;
iframe.height = iframeHeight;
iframe.frameBorder = '0';
iframe.scrolling = 'no';
iframe.allow = 'fullscreen';
document.getElementById('mintLive').appendChild(iframe);

// Resize iframe on window resize
window.addEventListener('resize', () => {
  const docWidth = document.documentElement.clientWidth;
  const iframeHeight = docWidth * 9 / 16;
  iframe.height = iframeHeight;
});
